import axios from 'axios';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Page from '../../../js/lib/page';
import { pageNames } from '../../common/constants';
import { CONTACT_CHANNEL_OPTIONS, CONTACT_TOPIC_TREE_INTENTS } from '../../common/storeConstants';
import { getCurrentPageName, isLoggedIn } from '../../helpers/twHelper';
import { isSetContextEnabled } from '../../../js/lib/omnichannelHelper';
import { updateContext } from '../../helpers/omniChannel/omniChannelHelper';
import { getContactChannels } from '../ContactOption/contactChannels';
import { getEcmArticleFptiTags } from '../../helpers/globalHelper';
import {
  isOmniChannelAPITriggeredInSession,
  removeOmniChannelAPITriggeredInSession,
} from '../../../js/lib/globalHelper';

const CONTACT_US_PAGE = 'contact-us';
const ARTICLE_URL = '/smarthelp/article-content';
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

// constants
export const REQUEST_ARTICLE = 'REQUEST_ARTICLE';
export const RECEIVE_ARTICLE_RESPONSE = 'RECEIVE_ARTICLE_RESPONSE';
export const RECEIVE_ARTICLE_ERROR = 'RECEIVE_ARTICLE_ERROR';
export const RESET_ARTICLE = 'RESET_ARTICLE';

export function requestArticle() {
  return {
    type: REQUEST_ARTICLE,
    payload: undefined,
  };
}

export function receiveArticle(responseData) {
  return {
    type: RECEIVE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

export function receiveArticleError() {
  return {
    type: RECEIVE_ARTICLE_ERROR,
    payload: undefined,
  };
}

export function resetArticle() {
  return {
    type: RESET_ARTICLE,
  };
}

export function fetchArticle(faqId, checkTechnical = false) {
  return (dispatch, getState) => {
    dispatch(requestArticle());
    const [faq] = faqId.split(',');
    // taking the flag set in updatebna and passing it as a param for the article-content
    const isPCC = !!window.localStorage.getItem('isBNA');
    let articleURL = `${ARTICLE_URL}?article_id=${faq}&isPCC=${isPCC}`;

    if (checkTechnical) {
      articleURL = Page.setChannelForTechnicalExp(articleURL);
    }

    // TODO: check Omni Channels and setContext
    // Checking the session storage for omni channel API triggered value from session
    const updateContextTriggered = isOmniChannelAPITriggeredInSession();
    const selectedFinalIntent = _get(getState(), `${CONTACT_TOPIC_TREE_INTENTS}.selectedFinalIntent`, {});
    const selectedOcpIntent = _get(getState(), `${CONTACT_TOPIC_TREE_INTENTS}.selectedOcpPrompt`, {});
    const isCustomerConfirmed = !_isEmpty(selectedOcpIntent) || false;

    // map the required keys from selectedFinalIntent data
    const topicDetails = {};
    if (selectedFinalIntent) {
      topicDetails.customerIntent = selectedFinalIntent.customer_intent;
      topicDetails.intentCode = selectedFinalIntent.intent_code;
      topicDetails.internalTreatment = selectedFinalIntent.internal_treatment;
      topicDetails.topicId = selectedFinalIntent.topic_id;
      topicDetails.topicName = selectedFinalIntent.topic_name;
      topicDetails.topicRefId = selectedFinalIntent.ref_id;
    }

    return axios
      .get(articleURL, {
        cancelToken: source.token,
      })
      .then((response) => {
        // Removing the isBna flag since we have already passed it as a param to article-content
        window.localStorage.removeItem('isBNA');
        if (response.data && response.data.articleContent) {
          dispatch(receiveArticle(response.data.articleContent));
          // IDI call - get the contact channels
          if (getCurrentPageName() === CONTACT_US_PAGE) {
            const kanaCode = _get(getState(), `${CONTACT_CHANNEL_OPTIONS}.kanaCode`, '');
            const topicName =
              response.data.articleContent.topicName ||
              _get(getState(), `${CONTACT_TOPIC_TREE_INTENTS}.selectedFinalIntent.topic_name`, '');
            dispatch(getContactChannels(kanaCode, topicName));
          }

          // If set context API already triggered when clicked on search results do not trigger the API again
          if (!updateContextTriggered && isLoggedIn()) {
            // get the ECM API tags from article data
            const { fptiDocId, fptiComponentIds } = getEcmArticleFptiTags(response.data.articleContent);
            const articleIntents = isSetContextEnabled(topicDetails, response.data);
            const dummyArticleContent = { channelDetails: articleIntents, faqId: faq };
            // update-context call
            const updateContextObj = {
              articleContent: dummyArticleContent,
              icfId: '',
              customerConfirmed: isCustomerConfirmed,
              fptiDocId,
              fptiComponentIds,
              pageName: getCurrentPageName() === CONTACT_US_PAGE ? pageNames.CONTACT_US : pageNames.HOME,
            };

            updateContext(updateContextObj);
          }

          // Removing OmniChannel API triggered value from session
          removeOmniChannelAPITriggeredInSession();
        }
      })
      .catch(() => {
        window.localStorage.removeItem('isBNA');
        dispatch(receiveArticleError());
        // IDI call - get the contact channels
        if (getCurrentPageName() === CONTACT_US_PAGE) {
          const kanaCode = _get(getState(), `${CONTACT_CHANNEL_OPTIONS}.kanaCode`, '');
          const topicName = _get(getState(), `${CONTACT_TOPIC_TREE_INTENTS}.selectedFinalIntent.topic_name`, '');
          dispatch(getContactChannels(kanaCode, topicName));
        }

        // If set context API already triggered when clicked on search results do not trigger the API again
        if (!updateContextTriggered && isLoggedIn()) {
          const articleIntents = isSetContextEnabled(topicDetails, {});
          const dummyArticleContent = { channelDetails: articleIntents, faqId: faq };
          // update-context call
          const updateContextObj = {
            articleContent: dummyArticleContent,
            icfId: '',
            customerConfirmed: isCustomerConfirmed,
            pageName: getCurrentPageName() === CONTACT_US_PAGE ? pageNames.CONTACT_US : pageNames.HOME,
          };

          updateContext(updateContextObj);
        }

        // Removing OmniChannel API triggered value from session
        removeOmniChannelAPITriggeredInSession();
      });
  };
}

export function fetchFAQIDData(responseData) {
  return (dispatch) => {
    const faqId = _get(responseData, 'formInfo.form_elements.faqid[0].default_text', undefined);
    if (faqId) {
      dispatch(fetchArticle(faqId));
    } else {
      dispatch(receiveArticleError());
    }
  };
}
